import React from 'react';
import { useTranslation , Trans } from 'react-i18next';


const TermsPage = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-xl overflow-hidden">
        
        {/* Header */}
        <div className="bg-[#1d5cab] px-8 py-6">
          <h1 className="text-3xl font-bold text-white">{t('terms.terms-and-conditions')}</h1>
          <p className="text-white mt-2">{t('terms.updated')}</p>
        </div>

        {/* Content */}
        <div className="p-8 space-y-8 text-gray-700 leading-relaxed">
          
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('terms.introduction')}</h2>
            <p>
              <Trans 
                i18nKey="terms.introduction-1" 
                values={{ company: t('nav.brand') }}
              >
              </Trans>
            </p>
            <p className="mt-2 text-sm text-gray-500">
              {t('terms.introduction-2')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2"> {t('terms.user-accounts')} </h2>
             <p> {t('terms.user-account-cond1')} </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('terms.service-providers')}</h2>
            <p>
              {t('terms.service-providers-intro')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('terms.compliance-header')}</h2>
            <p>
              {t('terms.compliance-1')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('terms.data-protection')}</h2>
            <p>
              {t('terms.data-protection-1')}
            </p>
            <ul className="list-disc pl-5 mt-2 space-y-2">
              <li>
              <Trans 
                i18nKey="terms.right-to-access-text" 
                values={{ title: t('terms.right-to-access') }}
              >
              </Trans>
              </li>
              <li>
              <Trans 
                i18nKey="terms.right-to-be-forgotten-text" 
                values={{ title: t('terms.right-to-be-forgotten') }}
              >
              </Trans>
              </li>
              <li>
              <Trans 
                i18nKey="terms.data-portability-text" 
                values={{ title: t('terms.data-portability') }}
              >
              </Trans>
              </li>  
            </ul>
            <p className="mt-2 text-sm italic">
              {t('terms.further-rights')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('terms.limitation-of-liability')}</h2>
            <p>
              <Trans 
                i18nKey="terms.limitation-1" 
                values={{ company: t('nav.brand') }}
              >
              </Trans>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('terms.dispute-resolutions')}</h2>
            <p>
              {t('terms.dispute-1')} </p>
            
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('terms.contact-us')}</h2>
            <p>
              {t('terms.contact-1')}
            </p>
            <address className="not-italic mt-2 text-gray-600">
              <strong> {t('company.legal-entity')} </strong><br />
              {t('company.address-1')}<br />
              {t('company.address-2')}<br />
              {t('company.legal-email')}
            </address>
          </section>

        </div>

        {/* Acknowledgement */}
        <div className="bg-gray-100 px-8 py-4 text-center text-sm text-gray-500">
          {t('terms.acknowledge')}
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
